const ITEMS = [
  "Always & Forever",
  "Chicago's Finest",
  "Sublimation / Airbrush / Thread",
  "By Monica Alexander",
  "New Merch Drop",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative py-10 sm:py-14 overflow-hidden border-y border-white/10" aria-hidden="true">
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center shrink-0">
                <span className="font-unbounded font-extrabold uppercase text-5xl sm:text-7xl lg:text-8xl text-outline px-8 whitespace-nowrap">
                  {item}
                </span>
                <span className="w-2.5 h-2.5 rotate-45 bg-[#ff1053]/70 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
